import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../views/HomePage.vue'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        redirect: '/index/HomePage',
    },

    {
        path: '/index',
        name: 'index',
        component: () => import('../views/Index.vue'),
        children: [
            //首页
            {
                path: '/index/HomePage',
                name: 'HomePage',
                component: () => import('../views/HomePage.vue'),
            },
            //协会概况
            {
                path: '/index/OrganList',
                name: 'OrganList',
                component: () => import('../views/organView/OrganList.vue'),
            },
            //动态信息
            {
                path: '/index/InfoList',
                name: 'InfoList',
                component: () => import('../views/infoView/InfoList.vue'),
            },
            //动态信息详情
            {
                path: '/index/InfoDetail',
                name: 'InfoDetail',
                component: () => import('../views/infoView/InfoDetail.vue'),
            },
            //联系我们
            {
                path: '/index/LinkList',
                name: 'LinkList',
                component: () => import('../views/linkView/LinkList.vue'),
            },
            //培训服务
            {
                path: '/index/TrainList',
                name: 'TrainList',
                component: () => import('../views/trainView/TrainList.vue'),
            },
             //培训服务详情
             {
                path: '/index/TrainDetail',
                name: 'TrainDetail',
                component: () => import('../views/trainView/TrainDetail.vue'),
            },
            //协会会员
            {
                path: '/index/VipList',
                name: 'VipList',
                component: () => import('../views/vipView/VipList.vue'),
            },
            //协会会员详情
            {
                path: '/index/VipDetail',
                name: 'VipDetail',
                component: () => import('../views/vipView/VipDetail.vue'),
            },
            //证书查询
            {
                path: '/index/CertSearch',
                name: 'CertSearch',
                component: () => import('../views/trainView/CertSearch.vue'),
            },
            //证书查询
            {
                path: '/index/CertDetail',
                name: 'CertDetail',
                component: () => import('../views/trainView/CertDetail.vue'),
            },
        ]
    }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js